import React from 'react';
import SbEditable from 'storyblok-react';
import Components from '../components.js';
import './press-news-mentions.scss';

const PressNewsMentions = (props) => {
  return (
    <SbEditable content={props.blok}>
      <section className="press-news-mentions-wrapper">
        <div className="press-news-mentions">
          <h3>In the News</h3>
          {props.blok.news_items &&
            props.blok.news_items.map((item) =>
              React.createElement(Components(item.component), { key: item._uid, blok: item })
            )}
        </div>
      </section>
    </SbEditable>
  );
};

export default PressNewsMentions;
